import { action, makeObservable, observable } from 'mobx';
import { IBuildInfo } from 'interfaces/buildInfo/IBuildInfo';
import { BuildInfoService } from 'services/data-services/BuildInfoService';

export class BuildInfoStore {
  private buildInfoService: BuildInfoService;

  @observable buildInfo: IBuildInfo | null = null;

  @observable isLoadingBuildInfo = false;

  constructor(buildInfoService: BuildInfoService) {
    this.buildInfoService = buildInfoService;
    makeObservable(this);
  }

  // Build info is informational only: a failure must never affect the rest of the UI, so the error is swallowed.
  @action initialize = async () => {
    this.isLoadingBuildInfo = true;
    try {
      this.buildInfo = await this.buildInfoService.getBuildInfo();
    } catch {
      this.buildInfo = null;
    } finally {
      this.isLoadingBuildInfo = false;
    }
  };
}
